import { Projet } from "../../../../../../utils/api/launchCampagn/projet.type";
import Commentaire from "../../../../compains/CampainsDetails/stepComponents/Commentaire";

export default ({ projet }: { projet: Projet }) => {
  return <Commentaire commentEnable={false} projet={projet} />;
};
